module.exports = __webpack_public_path__ + "img/1.52b61961.jpg";